.shell {
	display: flex;
	width: 100%;
	height: 100%;
	overflow: hidden;
	background: var(--parrot-chat-bg);
	color: var(--parrot-chat-text);
}
